import { get } from 'lodash';
import { connect } from 'react-redux';
import { userActions } from 'src/actions.js';
import { compose, mutation } from '../_shared/services/utils';
import NewReferralPageComponent from './NewReferralGdprComponent.jsx';

const mapStateToProperties = (state, props) => {
	const { params } = props.match;
	const id = get(params, 'webNotificationId')
		? params.webNotificationId
		: params.jobId;
	return {
		id,
		currentUser: state.user.currentUser,
		lang: props.match.params.lang,
		webNotificationId: props.match.params.webNotificationId,
		onUpdateContact,
		onUpdateWebNotification,
		onCreateReferral,
		ImportedCreateContact,
		params,
	};
};

const mapDispatchToProperties = (dispatch) => {
	return {
		setCurrentUser(user) {
			dispatch(userActions.createSetCurrentUserAction(user));
		},
	};
};

const onUpdateContact = async (input) => {
	return await mutation(input, 'updateContact');
};

const onUpdateWebNotification = async (input) => {
	return await mutation(input, 'updateWebNotification');
};

const onCreateReferral = async (input) => {
	return await mutation(input, 'createReferral');
};

const ImportedCreateContact = async (input) => {
	return await mutation(input, 'createContact');
};

const NewReferralPageWithApi = compose()(NewReferralPageComponent);

export const NewReferralPage = connect(
	mapStateToProperties,
	mapDispatchToProperties
)(NewReferralPageWithApi);
